import locationIconUrl from '@/assets/icons/location.svg'

import {
  AddressChip,
  AddressRow,
  AddressSuffix,
  BodyContent,
  BottomLinkButton,
  BottomNav,
  CtaButton,
  Headline,
  InstructionWrapper,
  TopGroup,
} from './AvailableResultStep.styles'

interface AvailableResultStepProps {
  /** 검색된 주소 (DB 데이터 그대로) */
  address: string
  /** "수거 신청하기" 클릭 시 호출 — Flutter 브릿지 onApply 트리거 (2차 검증 후) */
  onApply: () => void
  /** "서비스 가능 지역 보기" 클릭 시 호출 — bridge `enterServiceArea` 핸들러 (페이지 전환은 네이티브) */
  onEnterServiceArea: () => void
  /** 2차 검증 진행 중 — CTA 비활성화·중복 클릭 방어 */
  isApplying?: boolean
}

/**
 * 수거 가능 결과 화면 본문 — Figma 16392:29305.
 *
 * Layout:
 *  - BodyContent (flex 1, justify-between) — TopGroup ↔ "서비스 가능 지역 보기"
 *  - BottomNav (shrink-0) — 페이지 최하단 검정 CTA
 *
 * Fragment 로 두 영역 반환 → ResultWrapper 의 column flex 안에 직접 배치됨.
 *
 * 검색 인풋(SearchInputDisplay)은 부모(AddressSearchPage)가 본문 위에 그대로 그림.
 * "수거 신청하기" CTA → 2차 검증 → onApply()
 * "서비스 가능 지역 보기" 링크 → onEnterServiceArea() (네이티브가 화면 전환 처리)
 */
export default function AvailableResultStep({
  address,
  onApply,
  onEnterServiceArea,
  isApplying = false,
}: AvailableResultStepProps) {
  return (
    <>
      <BodyContent>
        <TopGroup>
          <img
            src={locationIconUrl}
            alt=''
            width={80}
            height={80}
          />
          <InstructionWrapper>
            <Headline>수거 가능한 지역이에요!</Headline>
            <AddressRow>
              <AddressChip>{address}</AddressChip>
              <AddressSuffix>은 서비스 중이에요</AddressSuffix>
            </AddressRow>
          </InstructionWrapper>
        </TopGroup>

        <BottomLinkButton
          type='button'
          onClick={onEnterServiceArea}>
          서비스 가능 지역 보기
        </BottomLinkButton>
      </BodyContent>

      <BottomNav>
        <CtaButton
          type='button'
          onClick={onApply}
          disabled={isApplying}
          aria-label='수거 신청하기'>
          수거 신청하기
        </CtaButton>
      </BottomNav>
    </>
  )
}
